import React from 'react';
import { Label } from "reactstrap";
import { FieldProps } from 'formik'

const AnswerCheckBox: React.FC<FieldProps & {
  id: string;
  label: string;
  value: string;
  alphabet?: any;
  show_quiz: boolean;
  active?:boolean;
  padclass?: string;
  optionCountValue:number;
  optionCountChange:(arg0: number) => void;

}> = ({
  field: { name, value, onBlur },
  form: { setFieldValue },
  id,
  label,
  value: radioValue,
  alphabet,
  show_quiz,
  active,
  optionCountValue,
  optionCountChange,
  ...props
}) => {
   console.log("STATUS :",active,label)
    return (
      <Label className={`quiz-live-answer-comp label-ans ${props.padclass}`} htmlFor={id}>
        <div className="l-ans-comp">
          <span className="alpha">{alphabet}</span>
          <p>{label}</p>
          <input
            name={name}
            id={id}
            type="checkbox"
            checked={value}
            onChange={e => {
              setFieldValue(name, e.target.checked)
              if(e.target.checked){
                 console.log("e.target.checked", e.target.checked);
                optionCountChange(optionCountValue+1)
              }else{
                optionCountChange(optionCountValue-1)
              }
            }}
            onBlur={onBlur}
            disabled={active}
            className="radio-button"
            {...props}
          />
          <span className="checkbox"></span>
        </div>
      </Label>
    );
  };

export default AnswerCheckBox;
